import { gql } from '@apollo/client'
import { processEnv } from 'components/configuration/environmentVariables'
import { AccountFirmFragment, FirmFragments } from '../fragments/firm.fragments'
import { FirmProfileInfoFragments } from '../fragments/firmProfileInfo.fragments'

// Base mutation fields that are always included
const baseMutationFields = `
    id
    name
    subscriptionInfo {
        ...subscriptionInfoFragment
    }
    displayName
    profileInfo {
        ...firmProfileInfoFragment
    }
    status
    supportContactUser {
        ...supportContactUserFragment
    }
    totalUsers
    totalReviewers
`

// Conditionally include MFA field based on feature flag
const mfaFields = processEnv.REACT_APP_ShowMFACheckbox === '1' ? 'isMFARequiredForLogins' : ''

export const UpdateFirmDisplayInfoMutation = gql`
    mutation updateFirmDisplayInfo(
        $updateFirmDisplayInfoInput: UpdateFirmDisplayInfoInput!
    ) {
        updateFirmDisplayInfo(input: $updateFirmDisplayInfoInput) {
            ${baseMutationFields}
            ${mfaFields}
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmProfileInfoFragments.firmProfileInfoFragment}
    ${FirmFragments.supportContactUserFragment}
`
export const UpdateFirmDisplayInfoPageMutation = gql`
    mutation updateFirmDisplayInfo(
        $updateFirmDisplayInfoInput: UpdateFirmDisplayInfoInput!
    ) {
        updateFirmDisplayInfo(input: $updateFirmDisplayInfoInput) {
            id
            firmId
            name
            displayName
            profileInfo {
                ...firmProfileInfoPageFragment
            }
        }
    }
    ${FirmProfileInfoFragments.firmProfileInfoPageFragment}
`
export const ResendUserInviteMutation = gql`
    mutation resendUserInvite($resendUserInviteInput: UserInviteInput!) {
        resendUserInvite(input: $resendUserInviteInput)
    }
`

export const CancelUserInviteMutation = gql`
    mutation cancelUserInvite($cancelUserInviteInput: UserInviteInput!) {
        cancelUserInvite(input: $cancelUserInviteInput)
    }
`
export const CreateFirmMutation = gql`
    mutation createFirm($firmInput: FirmInput!) {
        createFirm(firm: $firmInput) {
            ...accountFirmFragment
        }
    }
    ${AccountFirmFragment}
`

export const UpdateFirmMutation = gql`
    mutation updateFirm($firmInput: FirmInput!) {
        updateFirm(firm: $firmInput) {
            ...accountFirmFragment
        }
    }
    ${AccountFirmFragment}
`

export const ClearFirmAdminRegisteredMFADevices = gql`
    mutation clearFirmAdminRegisteredMFADevices(
        $input: ClearFirmAdminRegisteredMFADevicesInput!
    ) {
        clearFirmAdminRegisteredMFADevices(input: $input)
    }
`
